const DE = {
  translation: {
    pageTitle: {
      '400': 'Fehlerhafte Anfrage – 400',
      '401': 'Nicht authorisiert – 401',
      '403': 'Kein Zugriff – 403',
      '404': 'Nicht gefunden – 404',
      '500': 'Serverfehler – 500',
      account: 'Dein Account',
      login: 'Anmelden',
      dashboard: 'Dashboard',
      start: 'Start',
      courses: 'Kurse',
      courseMemberships: 'Abonnements',
      coursesCreate: 'Kurs erstellen',
      exercises: 'Übungen',
      exercisesCreate: 'Übung erstellen',
      flashcards: 'Karteikarten',
      flashcardsCreate: 'Karteikarte erstellen',
      flashcardDecks: 'Karten Decks',
      flashcardDecksCreate: 'Karten Deck erstellen',
      questions: 'Fragen',
      questionsCreate: 'Frage erstellen',
      units: 'Lektionen',
      unitsCreate: 'Lektion erstellen',
      users: 'Nutzer',
      usersCreate: 'Nutzer erstellen',
      announcements: 'Ankündigungen',
    },
    alerts: {
      loginToAccess: 'Bitte melde Dich an, um auf den Inhalt zugreifen zu können',
    },
    account: {
      headline: 'Dein Konto',
      notFound: 'Account nicht gefunden',
      security: {
        passwordInfo:
          'Falls Du Dein Passwort ändern möchtest, gib hier ein neues Passwort ein und bestätige es.',
      },
      loggedOut: 'Erfolgreich abgemeldet',
    },
    auth: {
      invalidCredentials: 'Anmeldedaten sind nicht korrekt',
    },
    courses: {
      headline: 'Kurse',
      testStatisticsSections: 'Test Statistik Sektionen',
      wpProductId: 'Woocommerce Product ID',
      create: {
        headline: 'Kurs erstellen',
      },
    },
    courseMemberships: {
      headline: 'Abonnements',
      create: {
        headline: 'Abonnement erstellen',
      },
    },
    exercises: {
      headline: 'Übungen',
      create: {
        headline: 'Übung erstellen',
      },
    },
    flashcards: {
      headline: 'Karteikarten',
      create: {
        headline: 'Karteikarten erstellen',
      },
    },
    flashcardDecks: {
      headline: 'Karten Decks',
      create: {
        headline: 'Karten Deck erstellen',
      },
    },
    questions: {
      headline: 'Fragen',
      create: {
        headline: 'Frage erstellen',
        welcome: 'Erstelle einen neue Frage',
      },
    },
    units: {
      headline: 'Lektionen',
      create: {
        headline: 'Lektion erstellen',
      },
      audioUrlHelper: 'Link file: https://domain.url/file.mp3',
      videoUrlHelper: 'Example: https://www.youtube.com/watch?v=ArcI4A5nvBo',
    },
    users: {
      headline: 'Nutzer',
      create: {
        headline: 'Nutzer erstellen',
      },
    },
    announcements: {
      headline: 'Ankündigungen',
      create: {
        headline: 'Ankündigung erstellen',
      },
      type: 'Typ',
      publishedAt: 'Veröffentlicht',
      releaseVersion: 'Release Version',
      releaseVersionHelper: 'z.B. v2.1.0 (nur für Release-Ankündigungen)',
      announcementHeadline: 'Überschrift (nutze H2)',
    },
    form: {
      helper: {
        questionTags: {
          quantity: "Max. Anzahl an Fragen für diesen Tag. '-1' für so viele wie vorhanden",
          tag: 'Aus Fragen mit diesem Tag auswählen',
          testRun: "Angeben, wenn je Test run andere Tags gewählt werden sollen. Beginnt mit '1'.",
          publishedCountTooltip: 'Veröffentlichte Fragen mit diesem Tag',
        },
        testRunSequences:
          "Gib bspw. '3' für 3 Test run Sequenzen an. Nach dem letzten starten wir wieder bei '1'.",
        processingTime: 'Dauer in Sekunden',
        extendBy: "z. B. '30 days' für 30 Tage, '6 months' für 6 Monate, '1 year' für 1 Jahr.",
      },
    },
    generic: {
      audioUrl: 'Audio URL',
      abbreviation: 'Kürzel',
      access: 'Zugang',
      account: 'Account',
      actions: 'Aktionen',
      add: 'Hinzufügen',
      addSource: 'Quelle hinzufügen',
      addAnswer: 'Antwort hinzufügen',
      addressAddition: 'Adresszusatz',
      apply: 'Anwenden',
      answer: 'Antwort',
      answers: 'Antworten',
      announcements: 'Ankündigungen',
      articles: 'Artikel',
      authors: 'Autoren',
      back: 'Zurück',
      cancel: 'Abbrechen',
      change: 'Ändern',
      chapters: 'Kapitel',
      changed: 'Geändert',
      city: 'Stadt',
      content: 'Inhalte',
      contentType: 'Inhaltstyp',
      copy: 'Kopieren',
      country: 'Land',
      countryPlaceholder: 'Deutschland',
      course: 'Kurs',
      courses: 'Kurse',
      courseMemberships: 'Mitgliedschaften',
      memberships: 'Mitgliedschaften',
      membership: 'Mitgliedschaft',
      correct: 'Richtig',
      create: 'Erstellen',
      created: 'Erstellt',
      createdAt: 'Erstellt',
      curriculum: 'Curriculum',
      dashboard: 'Dashboard',
      delete: 'Löschen',
      description: 'Beschreibung',
      design: 'Design',
      designDark: 'Dunkel',
      designLight: 'Hell',
      designPrompt: 'Wähle dein bevorzugtes Design:',
      designSystem: 'System',
      duration: 'Dauer',
      email: 'E-Mail-Adresse',
      end: 'Ende',
      exercise: 'Übung',
      exercises: 'Übungen',
      explanation: 'Erklärung',
      generalExplanation: 'Allgemeine Erklärung',
      explanationBlocks: 'Erklärungsblock',
      explanations: 'Erklärungen',
      filter: 'Filtern',
      firstName: 'Vorname',
      flashcard: 'Karteikarte',
      flashcards: 'Karteikarten',
      flashcardDecks: 'Karten Decks',
      general: 'Allgemein',
      hint: 'Hinweis',
      id: 'ID',
      icon: 'Icon',
      image: 'Bild',
      images: 'Bilder',
      index: 'Index',
      label: 'Label',
      labels: 'Labels',
      language: 'Sprache',
      lastLoginAt: 'Zuletzt eingeloggt am',
      lastName: 'Nachname',
      headline: 'Überschrift',
      list: 'Liste',
      loading: 'Lade...',
      login: 'Anmelden',
      logout: 'Abmelden',
      logs: 'Logs',
      menu: 'Menü',
      name: 'Name',
      new: 'Neues',
      noEntries: 'Keine Einträge vorhanden',
      noEntriesAdd:
        'Keine Einträge vorhanden. Klicke auf "Hinzufügen", um neue Einträge zu erstellen.',
      noEntriesSearchAndAdd:
        'Keine Einträge vorhanden. Suche Einträge und klicke sie an, um sie hinzuzufügen...',
      noEntriesForSearchTerm: 'Keine Einträge für den Suchbegriff gefunden',
      pages: 'Seiten',
      paragraphs: 'Absätze',
      password: 'Passwort',
      passwordRepetition: 'Passwort-Wiederholung',
      persons: 'Personen',
      publishedAt: 'Veröffentlicht',
      validUntil: 'Gültig bis',
      expirationType: 'Ablauf-Typ',
      extendBy: 'Verlängern um',
      phoneNumber: 'Telefonnummer',
      pleaseBePatient: 'Bitte habe einen Moment Geduld.',
      pleaseSelect: 'Bitte auswählen...',
      prefix: 'Prefix',
      price: 'Preis',
      private: 'Privat',
      profile: 'Profil',
      processingTime: 'Bearbeitungszeit',
      references: 'Referenzen',
      request: 'Anfragen',
      remove: 'Entfernen',
      reset: 'Zurücksetzen',
      role: 'Rolle',
      save: 'Speichern',
      saving: 'Speichern...',
      search: 'Suchen',
      searchAndAdd: 'Suchen und hinzufügen',
      security: 'Sicherheit',
      sessions: 'Sessions',
      slug: 'Slug',
      sourceId: 'Quell-ID',
      summary: 'Zusammenfassung',
      start: 'Start',
      status: 'Status',
      street: 'Straße & Hausnummer',
      title: 'Titel',
      unit: 'Lektion',
      units: 'Lektionen',
      untitled: 'Unbekannter Titel',
      unspecified: 'beliebig',
      updated: 'Geändert',
      updatedAt: 'Geändert',
      updateSearch: 'Suche anpassen',
      user: 'Nutzer',
      users: 'Nutzer',
      repeatable: 'Wiederholbar',
      testRunSequences: 'Anzahl der Test Runs',
      task: 'Aufgabe',
      tag: 'Tag',
      quantity: 'Anzahl',
      question: 'Frage',
      theme: 'Theme',
      testDate: 'Test Datum',
      testRun: 'Test Run',
      questionTags: 'Fragen Tags',
      questions: 'Fragen',
      questionEffect: 'Frageneffekt',
      shuffleQuestions: 'Fragen mixen',
      shuffleAnswers: 'Antworten mixen',
      solution: 'Lösung',
      videoUrl: 'Video URL',
      website: 'Webseite',
      showResult: 'Ergebnis anzeigen',
      selectQuestionsBy: 'Fragen auswählen nach',
      tags: 'Tags',
      text: 'Text',
      type: 'Typ',
      zipCode: 'Postleitzahl',
      wpUserId: 'WP User ID',
      version: 'Version',
      dataObject: 'Daten Objekt',
      props: 'Eigenschaften',
      errors: 'Fehler',
    },
    extensions: {
      addEmbed: 'Einbettung hinzufügen',
      insertHintBlock: 'Hinweisblock einfügen',
      insertMathBlock: 'Mathematikblock einfügen',
      insertInlineMath: 'Inline-Mathematik einfügen',
      insertImage: 'Bild einfügen',
      insertSource: 'Quelle einfügen',
      url: 'URL',
      width: 'Breite',
      height: 'Höhe',
      titleOptional: 'Titel (optional)',
      embedTitle: 'Einbettungstitel',
      validUrlError: 'Bitte gib eine gültige URL ein',
      invalidEmbedNoUrl: 'Ungültige Einbettung: Keine URL angegeben',
      editEmbed: 'Einbettung bearbeiten',
      openInNewTab: 'In neuem Tab öffnen',
      deleteEmbed: 'Einbettung löschen',
      saveEmbed: 'Einbettung speichern',
      embed: 'Einbettung',
      embedUrl: 'Einbettungs-URL',
      embeddedContent: 'Eingebetteter Inhalt',
      clickToEditFormula: 'Klicken Sie hier, um die Formel zu bearbeiten',
      enterLatexFormula: 'LaTeX-Formel eingeben (Strg+Enter zum Speichern, Escape zum Abbrechen)',
      formula: '[formel]',
      latexFormulaPlaceholder: 'LaTeX-Formel (Enter zum Speichern, Escape zum Abbrechen)',
      imageUrl: 'Bild-URL',
      removeImage: 'Bild entfernen',
      hintTypes: {
        mnemonic: 'Eselsbrücke',
        reminder: 'Merkhilfe',
        info: 'Info',
      },
    },
    dashboard: {
      title: 'Dashboard',
      headline: 'Dashboard',
      welcome: 'Willkommen im Dashboard!',
      tabs: {
        overview: 'Übersicht',
        users: 'Nutzer',
        courses: 'Kurse',
        learning: 'Lernen',
        content: 'Inhalte',
      },
      metrics: {
        activeUsers: 'Aktive Nutzer',
        totalUsers: 'Nutzer gesamt',
        newRegistrations: 'Neue Registrierungen',
        retentionRate: 'Retention Rate',
        courseCompletionRate: 'Kurs Abschlussrate',
        toPreviousPeriod: 'vorher. Zeitraum',
        monthly: 'Monatlich',
        month1: '1 Monat',
        totalCourses: 'Kurse gesamt',
        publishedCourses: 'Veröffentlichte Kurse',
        completedCourses: 'Abgeschlossene Kurse (100%)',
        averageCoursesPerUser: 'Ø Kurse pro Nutzer',
        totalMemberships: 'Abos gesamt',
        activeMemberships: 'Aktive Abos',
        expiredMemberships: 'Abgelaufene Abos',
        deactivatedMemberships: 'Deaktivierte Abos',
        total: 'Gesamt',
        inPeriod: 'Zeitraum',
        // Metric descriptions
        totalCoursesDesc: 'Allerstellten Kurse',
        averageCompletionRateDesc: 'Durchschnittliche Abschlussrate aller Kurse',
        completedCoursesDesc: 'Zu 100% abgeschlossenen Kurse',
        averageCoursesPerUserDesc: 'Durchschnittliche Kurse pro registriertem Nutzer',
        totalMembershipsDesc: 'Alle Kursabonnements',
        activeMembershipsDesc: 'Aktive Kursabonnements',
        expiredMembershipsDesc: 'Abgelaufene Kursabonnements',
        deactivatedMembershipsDesc: 'Deaktivierte Kursabonnements',
        totalUsersDesc: 'Alle registrierten Nutzer',
        activeUsersDesc: 'Aktive Nutzer',
        newRegistrationsDesc: 'Neue Nutzerregistrierungen',
        retentionRateDesc: 'Prozentsatz der Nutzer, die nach einem Monat noch aktiv sind',
        averageTimeToComplete: 'Ø Zeit bis Abschluss',
        averageEnrollmentsPerCourse: 'Ø Einschreibungen pro Kurs',
        newCourses: 'Neue Kurse',
        newEnrollments: 'Neue Einschreibungen',
        coursesCompleted: 'Kurse abgeschlossen',
        averageChaptersCompleted: 'Ø Kapitel abgeschlossen',
        averageStudySessionsPerCourse: 'Ø Lern-Sessions pro Kurs',
        averageCompletionRate: 'Ø Abschlussrate',
        averageTimeToCompleteDesc: 'Durchschnittliche Tage bis Abschluss',
        averageEnrollmentsPerCourseDesc: 'Durchschnittliche Einschreibungen pro Kurs',
        newCoursesDesc: 'Neue Kurse',
        newEnrollmentsDesc: 'Neue Einschreibungen',
        completionsDesc: 'Kursabschlüsse',
        averageChaptersCompletedDesc: 'Durchschnittliche abgeschlossene Kapitel pro Nutzer',
        averageStudySessionsPerCourseDesc: 'Durchschnittliche Anzahl der Lern-Sessions pro Kurs',
      },
      charts: {
        activeUsers: 'Aktive Nutzer',
        sessionStats: 'Session Statistiken',
        avgSessionDuration: 'Ø Session Dauer (Min)',
        totalSessions: 'Sessions Gesamt',
        totalActiveUsers: 'Aktive Nutzer Gesamt',
        peakUsageHours: 'Spitzenzeiten',
        coursePerformance: 'Kurs Performance',
        userDistribution: 'Nutzer Verteilung',
        noData: 'Keine Daten verfügbar',
        roles: {
          customer: 'Kunden',
          manager: 'Manager',
          admin: 'Administratoren',
          active: 'Aktiv',
          completed: 'Abgeschlossen',
          submitted: 'Ausgewertet',
          expired: 'Abgelaufen',
          deactivated: 'Deaktiviert',
          course: 'Kurs',
          test: 'Test',
        },
        retention: {
          week1: '1 Woche',
          month1: '1 Monat',
          month3: '3 Monate',
          rate: 'Retention Rate (%)',
        },
        activeUsersBreakdown: 'Aktive Nutzer Aufschlüsselung',
        activeUsersPeriods: {
          daily: 'Täglich',
          weekly: 'Wöchentlich',
          monthly: 'Monatlich',
        },
        value: 'Wert',
        users: 'Nutzer',
        rate: 'Rate',
        count: 'Anzahl',
        courseTypeDistribution: 'Kurs Typ Verteilung',
        courseLanguageDistribution: 'Kurs Sprach Verteilung',
        enrollmentTrends: 'Einschreibung Trends',
        performanceDistribution: 'Performance Verteilung',
        completionTimeDistribution: 'Abschlusszeit Verteilung',
        topPerformingCourses: 'Top Performing Kurse',
        courseEnrollmentStatus: 'Abo Status',
        // Chart descriptions
        activeUsersDesc: 'Zeigt die Entwicklung aktiver Nutzer über Zeit',
        userDistributionDesc:
          'Verteilung der Nutzer nach Rollen (Kunden, Manager, Administratoren)',
        retentionRateDesc:
          'Retention-Raten für verschiedene Zeiträume (1 Woche, 1 Monat, 3 Monate)',
        activeUsersBreakdownDesc:
          'Aufschlüsselung aktiver Nutzer nach Zeiträumen (täglich, wöchentlich, monatlich)',
        courseEnrollmentStatusDesc:
          'Verteilung der Kursabonnements nach Status (aktiv, abgelaufen, deaktiviert)',
        completionTimeDistributionDesc:
          'Verteilung der Zeit, die Nutzer zum Abschließen von Kursen benötigen',
        recentActivity: 'Letzte Aktivitäten',
        recentActivityDesc: 'Übersicht über die letzten Aktivitäten im System',
        engagementOverview: 'Engagement Übersicht',
        engagementOverviewDesc: 'Übersicht über das Nutzerengagement in Kursen',
        coursePerformanceSummary: 'Kurs Performance Zusammenfassung',
        coursePerformanceSummaryDesc: 'Zusammenfassung der wichtigsten Kurs-Performance-Metriken',
        courseStatusDistribution: 'Kurs Status Verteilung',
        courseStatusDistributionDesc:
          'Verteilung der Kurse nach Status (aktiv, eingereicht, abgeschlossen)',
        peakUsageHoursDesc: 'Spitzenzeiten der Nutzung nach Stunden',
        newUsers: 'Neue Nutzer',
        sessions: 'Sessions',
      },
      dateRange: {
        period: 'Zeitraum',
        last7Days: 'Letzte 7 Tage',
        last30Days: 'Letzte 30 Tage',
        last90Days: 'Letzte 90 Tage',
        thisYear: 'Dieses Jahr',
        lastYear: 'Letztes Jahr',
        yearBeforeLast: 'Vorletztes Jahr',
        custom: 'Benutzerdefiniert',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
      },
      recentActivity: {
        title: 'Letzte Aktivitäten',
      },
      users: {
        userGrowth: 'Nutzer Wachstum',
        activeUsers: 'Aktive Nutzer',
        roleDistribution: 'Rollen Verteilung',
        geographicDistribution: 'Geografische Verteilung',
        retentionCohort: 'Retention Kohorte',
        courseParticipation: 'Kurs Teilnahme',
        membershipStatus: 'Abonnement Status',
      },
      courses: {
        performanceOverview: 'Performance Übersicht',
        statusDistribution: 'Status Verteilung',
        enrollmentTrends: 'Einschreibung Trends',
        completionRates: 'Abschlussraten',
        popularCourses: 'Beliebte Kurse',
        dropOffPoints: 'Abbruch Punkte',
        creationTimeline: 'Erstellungs Timeline',
        languageDistribution: 'Sprach Verteilung',
      },
    },
    error: {
      default: 'Etwas ist schief gelaufen',
      delete: 'Löschen fehlgeschlagen',
      load: 'Laden fehlgeschlagen',
      save: 'Speichern fehlgeschlagen',
      create: 'Erstellen fehlgeschlagen',
      update: 'Ändern fehlgeschlagen',
      failedToAddAlreadyAdded: 'Hinzufügen fehlgeschlagen, da bereits vorhanden',
      failedToSendVerifyEmail: 'Bestätigungs-E-Mail konnte nicht an {{email}} versandt werden.',
      unknown: 'Ein unbekannter Fehler ist aufgetreten',
    },
    info: {
      addedNotSaved: 'Hinzugefügt (noch nicht gespeichert)',
      removedNotSaved: 'Entfernt (noch nicht gespeichert)',
    },
    success: {
      added: 'Erfolgreich hinzugefügt',
      removed: 'Erfolgreich entfernt',
      created: 'Erfolgreich erstellt',
      updated: 'Erfolgreich geändert',
      deleted: 'Erfolgreich gelöscht',
      changesSaved: 'Änderungen wurden gespeichert',
    },
    login: {
      forgotPassword: 'Passwort vergessen?',
      formHeadline: 'Anmelden',
      headline: 'Melde dich an',
      loggedIn: 'Erfolgreich angemeldet',
      loginFailed: 'Login fehlgeschlagen',
      loginBtn: 'Anmelden',
    },
    nav: {
      account: 'Account',
      content: 'Inhalte',
      create: 'Erstellen',
      dashboard: 'Dashboard',
      list: 'Liste',
      learnView: 'Lernansicht',
      login: 'Anmelden',
      myCourses: 'Kurse',
      register: 'Registrieren',
      users: 'Nutzer',
      courses: 'Kurse',
      memberships: 'Abos',
      questions: 'Fragen',
      units: 'Lektionen',
      exercises: 'Übungen',
      flashcards: 'Karten',
      flashcardDecks: 'Decks',
      announcements: 'News',
    },
    validate: {
      email: {
        invalid: 'Email ist ungültig',
      },
      password: {
        min: 'Passwort muss min. {{min}} Zeichen beinhalten',
        max: 'Passwort darf max. {{min}} Zeichen beinhalten',
        mismatch: 'Passwörter stimmen nicht überein',
      },
      question: {
        answers: 'Bitte überprüfen Sie Ihre Antworten',
        solution: 'Bitte überprüfen Sie Ihre Lösungsauswahl',
        solutionSingleChoice: 'Bitte für Single Choice genau eine richtige Antwort markieren',
        solutionMultipleChoice:
          'Bitte für Multiple Choice mindestens eine richtige Antwort markieren',
        trueFalseAnswerCount: 'True/False-Fragen müssen genau 2 Antworten haben',
        answerRequired: 'Mindestens eine Antwort ist erforderlich',
      },
      exercise: {
        questionsRequired: 'Mindestens eine Frage ist erforderlich',
        testRunSequencesRequired: 'Anzahl der Testläufe ist erforderlich',
      },

      generic: {
        required: 'Diese Angabe wird benötigt',
        validDate: 'Bitte ein gültiges Datum angeben',
        minNumber: 'Wert muss größer als {{min}} sein',
      },
    },
    errorPage: {
      btnLabel: 'Zur Startseite',
      '400': {
        headline: 'Ein Fehler ist aufgetreten – 400',
        message: 'Etwas mit der Anfrage ist schief gelaufen.',
      },
      '401': {
        headline: 'Nicht authorisiert – 401',
        message: 'Melde dich an, um auf den Inhalt zuzugreifen.',
      },
      '403': {
        headline: 'Keine Zugriffsrechte – 403',
        message: 'Du hast nicht die nötigen Zugriffsrechte für diesen Inhalt.',
      },
      '404': {
        headline: 'Inhalt nicht gefunden – 404',
        message: 'Der gesuchte Inhalt konnte nicht gefunden werden.',
      },
      '500': {
        headline: 'Ein Fehler ist aufgetreten – 500',
        message: 'Das System kann die Anfrage nicht verarbeiten.',
      },
    },
    userRoles: {
      customer: 'Kunde',
      'manager:flashcards': 'Manager Flashcards',
      manager: 'Manager',
      admin: 'Administrator',
    },
    questionType: {
      mc: 'Multiple Choice',
      mctf: 'Multiple Choice (Wahr/Falsch)',
      sc: 'Einfachauswahl',
      sq: 'Sequenz',
      tf: 'Wahr/Falsch',
    },
  },
};

export default DE;
